module.exports = __webpack_public_path__ + "img/sacrificial-greatsword.f724bf79.webp";